/* Regista quick buy fixes: gallery links and fit assistant inside injected quick-buy content */
(function () {
  "use strict";

  function neutralizeQuickBuyGalleryLinks(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(".quick-buy-modal .product-gallery__image[href]").forEach((link) => {
      link.dataset.registaOriginalHref = link.getAttribute("href") || "";
      link.removeAttribute("href");
      link.setAttribute("role", "presentation");
      link.setAttribute("tabindex", "-1");
    });
  }

  document.addEventListener("click", function (event) {
    const galleryLink = event.target.closest(".quick-buy-modal .product-gallery__image");
    if (galleryLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
  }, true);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          neutralizeQuickBuyGalleryLinks(node);
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    neutralizeQuickBuyGalleryLinks(document);
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      observer.observe(document.body, { childList: true, subtree: true });
      neutralizeQuickBuyGalleryLinks(document);
    }, { once: true });
  }

  document.addEventListener("listbox:change", function (event) {
    const option = event.target.closest('[role="option"][value]');
    const listbox = option && option.closest("x-listbox[data-option-selector]");
    if (!option || !listbox) return;

    const value = option.getAttribute("value");
    const radio = listbox.querySelector(`input[type="radio"][data-option-position][value="${CSS.escape(value)}"]`);
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }, true);

  document.addEventListener("click", function (event) {
    const openButton = event.target.closest(".quick-buy-modal [data-regista-fit-open]");
    if (!openButton) return;

    const quickBuy = openButton.closest(".quick-buy-modal");
    const fitModal = quickBuy && quickBuy.querySelector("[data-regista-fit-modal]");

    if (fitModal && fitModal.parentElement !== document.body) {
      document.body.appendChild(fitModal);
    }
  }, true);
})();



/* Regista quick buy clean V2 */
(function () {
  "use strict";

  document.addEventListener("click", function (event) {
    const openButton = event.target.closest(".quick-buy-modal [data-regista-fit-open]");
    if (!openButton) return;

    const quickBuy = openButton.closest(".quick-buy-modal");
    const fitModal = quickBuy && quickBuy.querySelector("[data-regista-fit-modal]");

    if (fitModal && fitModal.parentElement !== document.body) {
      fitModal.classList.remove("is-open");
      fitModal.setAttribute("aria-hidden", "true");
      document.body.appendChild(fitModal);
    }
  }, true);
})();



/* REGISTA QUICK FIT INLINE V3 */
(function () {
  "use strict";

  const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function normalize(value) {
    return String(value || "").toUpperCase().replace(/\s+/g, "").replace("XXXL", "3XL");
  }

  function variantSize(variant) {
    const values = [];
    if (variant.title) values.push(variant.title);
    if (Array.isArray(variant.options)) values.push(...variant.options);
    const joined = values.map(normalize).join("|");

    if (/(^|\|)3XL($|\|)/.test(joined)) return "3XL";
    if (/(^|\|)XXL($|\|)/.test(joined)) return "XXL";
    if (/(^|\|)XL($|\|)/.test(joined)) return "XL";
    if (/(^|\|)L($|\|)/.test(joined)) return "L";
    if (/(^|\|)M($|\|)/.test(joined)) return "M";
    if (/(^|\|)S($|\|)/.test(joined)) return "S";
    if (/(^|\|)XS($|\|)/.test(joined)) return "XS";
    return "";
  }

  function estimateSize(height, weight, pref) {
    let score = (weight - 52) / 11 + (height - 168) / 14;
    if (pref === "tight") score -= 0.42;
    if (pref === "loose") score += 0.48;
    const index = clamp(Math.round(score), 0, sizeOrder.length - 1);
    return sizeOrder[index];
  }

  function readProductData(root) {
    const script = root.querySelector("[data-regista-quick-fit-product]");
    if (!script) return { variants: [] };
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return { variants: [] };
    }
  }

  function nearestAvailable(size, variants) {
    const available = (variants || []).filter(v => v.available).map(v => ({ variant: v, size: variantSize(v) })).filter(v => v.size);
    if (!available.length) return { size, variant: null, exact: false };

    const exact = available.find(item => item.size === size);
    if (exact) return { size, variant: exact.variant, exact: true };

    const wanted = sizeOrder.indexOf(size);
    let best = available[0];
    let bestDistance = 99;

    available.forEach(item => {
      const distance = Math.abs(sizeOrder.indexOf(item.size) - wanted);
      if (distance < bestDistance) {
        best = item;
        bestDistance = distance;
      }
    });

    return { size: best.size, variant: best.variant, exact: false };
  }

  function selectSize(root, size, variantId) {
    const modal = root.closest("quick-buy-modal") || document;
    const formId = readProductData(root).formId;
    const form = formId ? document.getElementById(formId) : modal.querySelector("form[action*='/cart/add']");
    const normalizedSize = normalize(size);

    let clicked = false;

    modal.querySelectorAll("input[data-option-position], input[type='radio']").forEach(input => {
      if (clicked) return;
      const label = modal.querySelector(`label[for="${CSS.escape(input.id || "")}"]`);
      const text = normalize((label && label.textContent) || input.value || "");
      if (text === normalizedSize || text.includes(normalizedSize)) {
        input.click();
        input.dispatchEvent(new Event("change", { bubbles: true }));
        clicked = true;
      }
    });

    if (!clicked) {
      modal.querySelectorAll("select").forEach(select => {
        if (clicked) return;
        Array.from(select.options).forEach(option => {
          const text = normalize(option.textContent || option.value || "");
          if (!clicked && (text === normalizedSize || text.includes(normalizedSize))) {
            select.value = option.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            clicked = true;
          }
        });
      });
    }

    if (variantId && form) {
      const idInput = form.querySelector("input[name='id'], select[name='id']");
      if (idInput) {
        idInput.value = String(variantId);
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    return clicked;
  }

  function init(root) {
    if (!root || root.dataset.registaQuickFitReady === "true") return;
    root.dataset.registaQuickFitReady = "true";

    const toggle = root.querySelector("[data-regista-quick-fit-toggle]");
    const panel = root.querySelector("[data-regista-quick-fit-panel]");
    const result = root.querySelector("[data-regista-quick-fit-result]");
    const heightInput = root.querySelector("[data-regista-quick-fit-height]");
    const weightInput = root.querySelector("[data-regista-quick-fit-weight]");
    const calculate = root.querySelector("[data-regista-quick-fit-calculate]");
    let pref = "regular";

    toggle && toggle.addEventListener("click", () => {
      panel.hidden = !panel.hidden;
    });

    root.querySelectorAll("[data-regista-quick-fit-pref]").forEach(button => {
      button.addEventListener("click", () => {
        root.querySelectorAll("[data-regista-quick-fit-pref]").forEach(item => item.classList.remove("is-selected"));
        button.classList.add("is-selected");
        pref = button.getAttribute("data-regista-quick-fit-pref") || "regular";
      });
    });

    calculate && calculate.addEventListener("click", () => {
      const height = Number(heightInput.value);
      const weight = Number(weightInput.value);

      if (!(height >= 120 && height <= 230 && weight >= 35 && weight <= 180)) {
        result.hidden = false;
        result.innerHTML = "תכניס גובה ומשקל תקינים כדי לחשב מידה.";
        return;
      }

      const productData = readProductData(root);
      const estimated = estimateSize(height, weight, pref);
      const available = nearestAvailable(estimated, productData.variants || []);

      result.hidden = false;
      result.innerHTML = `
        <div>המידה המומלצת עבורך היא <strong>${available.size}</strong></div>
        ${available.exact ? "<small>המידה קיימת במלאי.</small>" : `<small>ההמלצה המקורית הייתה ${estimated}, בחרנו את המידה הקרובה ביותר שקיימת במלאי.</small>`}
        ${available.variant ? `<br><button type="button" class="regista-quick-fit__select" data-regista-quick-fit-select data-size="${available.size}" data-variant-id="${available.variant.id}">בחר מידה ${available.size}</button>` : ""}
      `;
    });

    root.addEventListener("click", event => {
      const select = event.target.closest("[data-regista-quick-fit-select]");
      if (!select) return;
      const size = select.getAttribute("data-size");
      const variantId = select.getAttribute("data-variant-id");
      selectSize(root, size, variantId);
      select.textContent = `מידה ${size} נבחרה`;
    });
  }

  function scan() {
    document.querySelectorAll("[data-regista-quick-fit]").forEach(init);
  }

  document.addEventListener("click", event => {
    const root = event.target.closest("[data-regista-quick-fit]");
    if (root) init(root);
  }, true);

  document.addEventListener("DOMContentLoaded", scan);
  window.addEventListener("load", scan);

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
